module["exports"] = ["Jr.", "Sr.", "I", "II", "III", "IV", "V"];